export const getObjectUrlFromBlob = async (fileUrl: string) => {
    try {
      const response = await fetch(fileUrl);
  
      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`);
      }
  
      const blob = await response.blob();
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error('Error in getObjectUrlFromBlob:', error);
      throw error; // Let the caller handle errors
    }
  };